import { render, staticRenderFns } from "./4-1.vue?vue&type=template&id=2fd611cc&scoped=true&"
import script from "./4-1.vue?vue&type=script&lang=js&"
export * from "./4-1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd611cc",
  null
  
)

export default component.exports